module.exports = __webpack_public_path__ + "img/NH_SA_kit.c162139d.png";